import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-base-modal',
    templateUrl: './base-modal.component.html',
    styleUrls: ['./base-modal.component.scss'],
})
export class BaseModalComponent implements OnInit, OnDestroy {
    @Input()
    title: string;

    @Input()
    disableClose = false;

    @Input()
    hideActions = false;

    @Input()
    bodyClass = 'mr-6 ml-6';

    @Input()
    actionPosition: 'start' | 'center' | 'end' = 'center';
    hideHeader = false;
    beforeClosedSubs: Subscription;

    constructor(private dialogRef: MatDialogRef<any>) {}

    dialogClose() {
        this.dialogRef.close();
    }

    ngOnInit(): void {
        this.beforeClosedSubs = this.dialogRef.beforeClosed().subscribe( () => {
            this.hideHeader = true;
        });
        // Eliminates the possibility of marking undefined on the screen
        if (this.title === undefined) {
            this.title = '';
        }
    }

    ngOnDestroy(): void {
        this.beforeClosedSubs.unsubscribe();
    }

    get justifyContent() {
        return { 'justify-content': this.actionPosition };
    }
}
